import React from "react";
import { Link } from "react-router-dom";
import { useGetPageQuery } from "../../redux/services/crmAPI";
import "./productTable.scss";

const ProductTable = () => {
    const { data: products } = useGetPageQuery(`products?per_page=20`);

    return (
        <>
            {products?.data?.length > 0 && (
                <>
                    {" "}
                    <div className="col-12 col-sm-6 col-md-6">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">ID</th>
                                    <th scope="col">Назва</th>
                                    <th scope="col">Ціна</th>
                                </tr>
                            </thead>
                            <tbody>
                                {products.data.map((product, index) => {
                                    if (index < 10) {
                                        return (
                                            <tr key={product.id}>
                                                <td className="fit">#{product.id}</td>
                                                <td>
                                                    <Link
                                                        className="table__link"
                                                        to={"/product/" + product.id}
                                                    >
                                                        {product.title}
                                                        {product?.imei_sn
                                                            ? "(" +
                                                              product.imei_sn.slice(product.imei_sn.length - 5) +
                                                              ")"
                                                            : ""}
                                                    </Link>
                                                </td>
                                                <td className="fit">{product.price} грн</td>
                                            </tr>
                                        );
                                    }
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className="col-12 col-sm-6 col-md-6">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">ID</th>
                                    <th scope="col">Назва</th>
                                    <th scope="col">Ціна</th>
                                </tr>
                            </thead>
                            <tbody>
                                {products.data.map((product, index) => {
                                    if (index >= 10) {
                                        return (
                                            <tr key={product.id}>
                                                <td className="fit">#{product.id}</td>
                                                <td>
                                                    <Link
                                                        className="table__link"
                                                        to={"/product/" + product.id}
                                                    >
                                                        {product.title}
                                                        {product?.imei_sn
                                                            ? "(" + product.imei_sn.slice(0, 5) + ")"
                                                            : ""}
                                                    </Link>
                                                </td>
                                                <td className="fit">{product.price} грн</td>
                                            </tr>
                                        );
                                    }
                                })}
                            </tbody>
                        </table>
                    </div>
                </>
            )}
        </>
    );
};

export default ProductTable;
